'use strict';

import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames/bind';

import { appSelectors, appOperations } from '@/state/domains/app';
import { usersOperations, usersSelectors } from '@/state/domains/users';

import s from './styles.scss';

const sx = cn.bind(s);

export default connect(
	(state, props) => ({
		responsive: appSelectors.getResponsive(state, props),
		isRouterInProgress: appSelectors.isRouterInProgress(state, props),
		loggedInUser: usersSelectors.getLoggedInUser(state, props),
		pageUser: usersSelectors.getPageUser(state, props),
	}),
	{
		fetchUser: usersOperations.fetchUser,
	}
)(
	({
		responsive,
		isRouterInProgress,
		loggedInUser,
		pageUser,
		username,
		fetchUser,
		overlays,
		header: Header,
		main: Main,
	}) => {
		
		if (isRouterInProgress) {
			return <div />;
		}

		return (
			<div className={ s.root }>
				<div className={ s.overlays }>
					{
						overlays.map(
							(Comp, i) => <Comp key={ i }/>
						)
					}
				</div>
				<header className={ sx('header', { mobile: !responsive.md }) }>
					<Header />
				</header>
				<section className={ s.main }>
					<Main />
				</section>
			</div>
		);
	}
);
